import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#D46A19",
    },
    secondary: {
      main: "#620A15",
    },
  },
});

export default theme;
